// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Blurb.propTypes = {
  handleModal: PropTypes.func.isRequired,
};

// this are the details for this attestation field
export function Config() {
  return {
    name: 'inPersonClasses', // this used as the field name as well as the unique identifier
    productIds: [
      '0746780f-df95-4bb5-a923-08dda364e4be', // 07/16/2025 - Chickopee/Springfield Classroom/Online 10-Hour Package
      'a076089e-3e06-4dec-707c-08dda361dc16', // 07/17/2025 - Worcester/Fitchburg Classroom/Online 10-Hour Package
      'a48c735f-8b48-4a8c-707d-08dda361dc16', // 07/16/2025 - Chickopee/Springfield Classroom/Online 12-Hour Package
      'e894e25e-038b-472f-a922-08dda364e4be', // 07/17/2025 - Worcester/Fitchburg Classroom/Online 12-Hour Package
      '8e635d4b-af37-4811-9e00-08dd985d0ca7', // 7/16/2025 - Chicopee/Springfield 6 Hour Classroom
      '8e761aa8-73d1-4f13-9e01-08dd985d0ca7', // 7/17/2025 - Worcester/Fitchburg 6 Hour Classroom
      '82fb46cf-ae42-467e-e50e-08dda2941c73', // 8/27/2025 - Woburn 6 Hour Classroom
      '9a958a08-a725-45cc-a921-08dda364e4be', // 10/04/2025 - Hyannis/Cape Cod 6 Hour Classroom
      'a1c38db0-ea84-478c-e506-08dda2941c73', // 10/09/2025 - Worcester/Fitchburg 6 Hour Classroom
    ],
    errorMsg: `You must agree with the <strong>in-person class</strong> terms by typing "<strong>I agree</strong>" in the highlighted box.`,
    onlyForBulk: false, // set to true if this attestation is only for bulk purchase
    type: 'iAgree', // iAgree, signature, checkbox
  };
}

// this is the blurb we display to tell the user what this attestation field is for
export function Blurb() {
  return (
    <>
      <p>
        In order to receive credit for completing in-person classes, you must create an account and provide important
        licensing information, i.e. license number, address, etc. Follow these easy steps to create an account post-purchase:
      </p>
      <p className="ps-3">
        <strong>Step 1</strong>: Register for an account. You will have an opportunity to register immediately after
        purchase.
        <br />
        <strong>Step 2</strong>: Log in to your account.
        <br />
        <strong>Step 3</strong>: Follow the prompts to complete your required certificate information.
        <br />
      </p>
      <p className="mb-0">
        Please type “I agree” in the field below to confirm that you have read and understood this message.
      </p>
    </>
  );
}

// this is the explaination of the attestation, the full details of what the user is aggreeing to
export function ModalContent() {
  return null;
}
